export default {"src":"/_next/static/image/src/components/ComparisonChart/ollie-logo.e116b3fa7754b2549e21dea8508da91f.svg","height":29,"width":59};